import type { PaymentMethod } from 'src/app/pages/promote/shared/types';
import type { PaymentType as TrackingPaymentType } from 'src/app/shared/utils/payments';
import { paymentMethod as getPaymentMethod } from 'src/app/shared/utils/payments';

import { useDeviceData } from './useDeviceData';
import { useSetupFutureUsage } from './useSetupFutureUsage';

export function usePromotionChargePaymentMethod(): (paymentType: TrackingPaymentType, token?: string) => PaymentMethod {
	const setupFutureUsage = useSetupFutureUsage();
	const getDeviceData = useDeviceData();

	return function promotionChargePaymentMethod(paymentType, token) {
		const paymentMethod = getPaymentMethod(paymentType, token);
		return {
			...paymentMethod,
			...setupFutureUsage(paymentMethod.gateway, paymentType),
			...getDeviceData(paymentType),
		};
	};
}
